<template>
    <BCol cols="12" :md="vsMd">
        <ValidationProvider #default="validationContext" :name="$t(vsName)" :rules="vsRules">
            <BFormGroup :label="$t(vsName)" :label-for="encodeURIComponent(vsName).replace('%20','_').toLowerCase()" :class="vsRequired == '' ? 'required-field' : ''">
                <flatPickr  :value="vsModel"  class="form-control invoice-edit-input"  :config="flatpickrOptions" @input="inputFunctions($event)"/>

                <!-- <BFormDatepicker start-weekday="1"  :reset-button="vsReset" :disabled="vsDisabled" @input="inputFunctions($event)" :value="vsModel" locale="es" :min="data" :max="vsMax"></BFormDatepicker> -->
                <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{validationContext.errors[0]}} </BFormInvalidFeedback>
            </BFormGroup>
        </ValidationProvider>
    </BCol>
</template>

<script>
import { BCol, BFormGroup, BFormDatepicker, BFormInvalidFeedback } from 'bootstrap-vue';
import { toRefs, watch, ref, onMounted } from '@vue/composition-api';
import { ValidationProvider } from 'vee-validate';
import formValidation from '@core/comp-functions/forms/form-validation';
import flatPickr from 'vue-flatpickr-component'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import { Spanish} from "flatpickr/dist/l10n/es.js"
export default {
    components:{ ValidationProvider, BCol, BFormGroup, BFormDatepicker, BFormInvalidFeedback, flatPickr},
    props: ['vsName','vsDisabled' , 'vsModel', 'vsMd', 'vsRules', 'vsRequired', 'vsMin', 'vsMax', 'vsReset'],
    emit: ['update:vsModel', 'vsOnInput'],
    setup(props,  ctx) {
        const { getValidationState } = formValidation()
        const { vsMin, vsModel } = toRefs(props)
        const data=ref(null)
        const flatpickrOptions = {
            plugins: [
                new monthSelectPlugin({
                shorthand: true,
                dateFormat: "m-Y",
                altFormat: "F Y",
                    }),
            ],
            locale: Spanish
        };
        // watch(vsMin, () =>{
        //     minDate()
        // })


        // const minDate = () => {
        //     data.value= new Date(vsMin.value)
        //     data.value.setDate(data.value.getDate() + 1)
        //     data.value=data.value.toISOString().split("T")[0];
            
        //     if(new Date(data.value) > new Date(vsModel.value)){
        //         ctx.emit('update:vsModel', null)
        //     }
        // }

        const inputFunctions = function(event){
            ctx.emit('update:vsModel', event)
            ctx.emit('vsOnInput', event)
        }

        // if (vsMin.value) {
        //     minDate()
        // }


        



        return {
            getValidationState,
            data,
            inputFunctions,
            flatpickrOptions
        }
    },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-flatpicker.scss';

    .flatpickr-monthSelect-months {
        width:100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
    }

    .flatpickr-monthSelect-month {
        display: inline-block;
        padding:0.4em 1em;
        
    }
    .flatpickr-monthSelect-month:hover {
        cursor:pointer;
    }

    .flatpickr-innerContainer {
        display:block;
    }
</style>